import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=dfc5b7c2&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=js&"
export * from "./privacy-policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=dfc5b7c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc5b7c2",
  null
  
)

component.options.__file = "privacy-policy.vue"
export default component.exports